export default __webpack_public_path__ + "static/media/device-models-phone.84ae6581.jpg";